import React, { forwardRef } from "react";
import * as _f_ from "@Funciones/funciones";
import "@Estilos/Div.css";

export const CheckBox = forwardRef(({
  texto = "",
  name = "",
  estilos = {},
  className = "",
  checked,
  defaultChecked = false,
  onChange,
  disabled = false,
  ...props
}, ref) => {
  /* Si se pasa 'checked' de forma explícita, actúa como controlado.
     De lo contrario, usa 'defaultChecked' permitiendo la interacción nativa. */
  const esControlado = checked !== undefined;

  return (
    <label 
      className={`Tabla-label-checkbox ${className}`.trim()} 
      style={estilos}
    >
      <input 
        ref={ref}
        type="checkbox" 
        name={name}
        {...(esControlado ? { checked } : { defaultChecked })}
        onChange={onChange}
        disabled={disabled}
        {...props} 
      />
      {texto && <span>{texto}</span>}
    </label>
  );
});

CheckBox.displayName = "CheckBox";

export default CheckBox;